export default {
    ORDER_API_URL: '//www.sensoro.com',
    IOT_API_URL: '//iot-api.sensoro.com'
}



//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = null
// module chunks = 